<template>
  <div class="provincial_selection">
    <div class="select-city">
      <el-select v-model="params[provinceProp]" placeholder="请选择省" class="city-select" :style="`width: ${width}`"
                 @change="cityChange(params[provinceProp],'city')">
        <el-option v-for="item in province" :key="item.code" :label="item.name" :value="item.code">
        </el-option>
      </el-select>
      <el-select v-model="params[cityProp]" placeholder="请选择市" class="city-select" :style="`width: ${width}`" :prop="cityProp"
                 @change="cityChange(params[cityProp],'county')">
        <el-option v-for="item in city" :key="item.code" :label="item.name" :value="item.code">
        </el-option>
      </el-select>
      <el-select v-if="showCounty" v-model="params[countyProp]" placeholder="请选择区" class="city-select" :style="`width: ${width}`">
        <el-option v-for="item in county" :key="item.code" :label="item.name" :value="item.code">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
  export default {
    name: "provincial_selection",
    props: {
      params: {//数组对象
        type: Object
      },
      showCounty:{
        type: Boolean,
        default: false
      },
      provinceProp: { //数组对应的省字段的key
        type: String,
        default: 'province'
      },
      cityProp: { //数组对应的市字段的key
        type: String,
        default: 'city'
      },
      countyProp: { //数组对应的区县字段的key
        type: String,
        default: 'county'
      },
      width: {
        type: String,
        default: '120px'
      }
    },
    data() {
      return {
        // params:{
        //     province:null, //省编码
        //     city:  null,   //城市编码
        //     county: null,  //区县编码
        // },
        // provinceProp: 'province', //对应字段 params.province   示例：params[provinceProp]
        // cityProp: 'city',//对应字段 params.city
        // countyProp: 'countyProp',//对应字段 params.county
        province: [],
        city: [],
        county: [],
      }
    },
    watch: {
      provinceVal(val, old) { //监听省字段的变化，有变化就获取市的字典数据
        if (val && val !== old) {
          this.params[this.provinceProp] ? this.getDictionaries(this.params[this.provinceProp], 'city') : '' //如果省的字段不为空获得市
        }
      },
      cityVal(val, old) { //监听市字段的变化，有变化就获取区的字典数据
        if (val && val !== old) {
          this.params[this.cityProp] ? this.getDictionaries(this.params[this.cityProp], 'county') : '' //如果市的字段不为空获得区
        }
      }
    },
    computed: {
      provinceVal: function () {  //实时计算省字段
        return this.params[this.provinceProp]
      },
      cityVal: function () {  //实时计算市字段
        return this.params[this.cityProp]
      },
    },
    created() {
      this.getDictionaries('China', 'province'); //获得省

      //如果省不为空
      if (this.params[this.provinceProp] && this.params[this.provinceProp] !== 'undefined') {
        this.getDictionaries(this.params[this.provinceProp], 'city')
      }
      //如果市不为空
      if (this.params[this.cityProp] && this.params[this.cityProp] !== 'undefined') {
        this.getDictionaries(this.params[this.cityProp], 'county')
      }
    },
    methods: {
      /** 获取字典数据 */
      getDictionaries(typeCode, key) {
        let params = {
          typeCode: typeCode,
          pageNo: 0,
          pageSize: 999
        };
        this.api.getDictionaries(params).then(
          res => {
            this[key] = res.obj.list;
          }
        );
      },
      /** 省市区选择切换*/
      cityChange(val, key) {
        if (key === 'city') {
          this.params[this.cityProp] = ''
          this.params[this.countyProp] = ''
        } else if (key === 'county') {
          this.params[this.countyProp] = ''
        }
        // this.params.address = '';
        this.getDictionaries(val, key); //获得省

        this.$emit("changeCity",val)
      },
    }

  }
</script>

<style lang="scss">
  .provincial_selection {
    .select-city {
      /*width: 400px;*/
      display: flex;

      .city-select {
        width: 120px;

        .el-input {
          width: 100% !important;

          input {
            width: 100% !important;
          }
        }
      }
    }

    .select-city > div {
      margin-right: 10px;
    }
  }


</style>
